import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit{
    title: string;
    message: string;
    dataName: string;
    dataValue: string;
    hideTextField = true;
    cancelTitle: string;
    acceptTitle: string;
    textBox: boolean;
    inputBox: boolean;
    form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
        // Update view with given values
        this.title = data.title;
        this.message = data.message;
        this.cancelTitle = data.cancelTitle;
        this.acceptTitle = data.acceptTitle;
        this.textBox = data.textBox;
        if (typeof(data.dataName) !== 'undefined') {
            this.hideTextField = false;
            this.dataName = data.dataName;
            this.dataValue = data.dataValue;
        }
        if (!this.hideTextField && !this.textBox) {
            this.inputBox = true;
        }
        console.log(data);
        console.log(this.hideTextField);
        console.log(data.textBox);

    }
    ngOnInit(): void
    {
        this.form = this.fb.group({
            dataValue: [this.dataValue, []]
        });
    }
    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(this.form.value);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close();
    }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

    constructor(
        public title: string,
        public message: string,
        public dataName: string,
        public dataValue: string,
        public cancelTitle: string,
        public acceptTitle: string,
        public textBox: boolean,
    )
    {

    }
}
